import { useLang } from "@/context/LanguageContext";
import { GraduationCap } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="mt-24 border-t border-border bg-surfaceAlt">
      <div className="mx-auto max-w-7xl px-5 py-10 lg:px-8">
        <div className="flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-2xl bg-primary text-primary-foreground">
            <GraduationCap className="h-4 w-4" strokeWidth={1.75} />
          </span>
          <span className="font-heading text-base font-semibold text-foreground">{t("brand")}</span>
        </div>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground" data-testid="footer-note">
          {t("footer_note")}
        </p>
        <p className="mt-4 text-xs text-muted-foreground">© {new Date().getFullYear()} HISD Family Helper · Houston, TX</p>
      </div>
    </footer>
  );
};
